import { jsx as _jsx } from "react/jsx-runtime";
import { ClipboardCheck, FileText, History, Layers, LayoutDashboard, ListChecks, MessagesSquare, Users } from 'lucide-react';
const icon = 'h-4 w-4 flex-shrink-0';
/**
 * §4.2 RFI response registry (base `/rfi-response/:id`). An RFI has one
 * response document (D10): `document` opens it at the top and
 * `questions/:sectionId` opens it at that question's heading bookmark. There is
 * no per-question editor.
 */ export const RFI_NAV_GROUPS = [
    {
        id: 'workspace',
        label: 'Workspace',
        items: [
            {
                id: 'home',
                label: 'Home',
                path: '',
                icon: /*#__PURE__*/ _jsx(LayoutDashboard, {
                    className: icon
                })
            },
            {
                id: 'document',
                label: 'Response document',
                path: 'document',
                icon: /*#__PURE__*/ _jsx(FileText, {
                    className: icon
                })
            },
            {
                id: 'questions',
                label: 'Questions',
                path: 'questions',
                icon: /*#__PURE__*/ _jsx(ListChecks, {
                    className: icon
                }),
                countKey: 'questions',
                countLabel: 'questions'
            },
            {
                id: 'capability-statement',
                label: 'Capability statement',
                path: 'capability-statement',
                icon: /*#__PURE__*/ _jsx(FileText, {
                    className: icon
                })
            },
            {
                id: 'reviews',
                label: 'Reviews',
                path: 'reviews',
                icon: /*#__PURE__*/ _jsx(ClipboardCheck, {
                    className: icon
                }),
                countKey: 'reviews',
                countLabel: 'reviews'
            },
            {
                id: 'chat',
                label: 'Chat history',
                path: 'chat',
                icon: /*#__PURE__*/ _jsx(MessagesSquare, {
                    className: icon
                })
            }
        ]
    },
    {
        id: 'sources',
        label: 'Sources',
        items: [
            {
                id: 'notice',
                label: 'Notice and attachments',
                path: 'notice',
                icon: /*#__PURE__*/ _jsx(FileText, {
                    className: icon
                }),
                countKey: 'notice_files',
                countLabel: 'files'
            },
            {
                id: 'labor-categories',
                label: 'Labor categories',
                path: 'labor-categories',
                icon: /*#__PURE__*/ _jsx(Users, {
                    className: icon
                }),
                countKey: 'labor_categories',
                countLabel: 'labor categories'
            },
            {
                id: 'amendments',
                label: 'Q&A and amendments',
                path: 'amendments',
                icon: /*#__PURE__*/ _jsx(Layers, {
                    className: icon
                }),
                countKey: 'amendments',
                countLabel: 'amendments'
            },
            {
                id: 'past-answers',
                label: 'Past answers',
                path: 'past-answers',
                icon: /*#__PURE__*/ _jsx(History, {
                    className: icon
                }),
                countKey: 'past_answers',
                countLabel: 'past answers'
            },
            {
                id: 'team',
                label: 'Team',
                path: 'team',
                icon: /*#__PURE__*/ _jsx(Users, {
                    className: icon
                }),
                countKey: 'team',
                countLabel: 'team members'
            }
        ]
    }
];
/** Last breadcrumb per section slug ('' = record home). */ export const RFI_SECTION_LABELS = {
    '': 'Home',
    document: 'Response document',
    questions: 'Questions',
    'capability-statement': 'Capability statement',
    reviews: 'Reviews',
    chat: 'Chat history',
    notice: 'Notice and attachments',
    'labor-categories': 'Labor categories',
    amendments: 'Q&A and amendments',
    'past-answers': 'Past answers',
    team: 'Team'
};
/**
 * Link to one question: the response document at that question's heading.
 * `sectionId` = `rfi_response_sections.id`; the editor resolves the row's
 * `anchor_bookmark` (WRT §3.3).
 */ export function rfiQuestionHref(rfiResponseId, sectionId) {
    return `/rfi-response/${rfiResponseId}/questions/${sectionId}`;
}
/** "6 Nov". */ export function formatRfiDue(d) {
    return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short'
    });
}
